import { Navigate, useRoutes } from 'react-router-dom';
// layouts
import DashboardLayout from './layouts/dashboard';
import SimpleLayout from './layouts/simple';
//
import BlogPage from './pages/BlogPage';
import UsersPage from './pages/UsersPage';
import SLOBiHClanovi from './pages/SLOBiHClanovi';
import DevicesPage from './pages/DevicesPage';
import UserDevicesPage from './pages/UserDevicesPage';
import ClanOruzje from './pages/ClanOruzje';
import ClanKerovi from './pages/ClanKerovi';
import ClanOdlikovanja from './pages/ClanOdlikovanja';
import ClanProfil from './pages/ClanProfil';
import OnlineDevicesPage from './pages/OnlineDevicesPage';
import TestPage from './pages/TestPage';
import LoginPage from './pages/LoginPage';
import Page404 from './pages/Page404';
import ProductsPage from './pages/ProductsPage';
import DashboardAppPage from './pages/DashboardAppPage';

import CreateHunter from './pages/SubscriberCRUDPages/create';
import ReadHunter from './pages/SubscriberCRUDPages/read';
import UpdateHunter from './pages/SubscriberCRUDPages/update';
import UpdateHunterPhoto from './pages/SubscriberCRUDPages/updatephoto';

import CreateRifle from './pages/RifleCRUDPages/create';
import ReadRifle from './pages/RifleCRUDPages/read';
import UpdateRifle from './pages/RifleCRUDPages/update';

import CreateAward from './pages/AwardCRUDPages/create';
import ReadAward from './pages/AwardCRUDPages/read';
import UpdateAward from './pages/AwardCRUDPages/update';

import CreatePunishment from './pages/PunishmentCRUDPages/create';
import ReadPunishment from './pages/PunishmentCRUDPages/read';
import UpdatePunishment from './pages/PunishmentCRUDPages/update';

import CreateDog from './pages/DeviceCRUDPages/create';
import ReadDog from './pages/DeviceCRUDPages/read';
import UpdateDevice from './pages/DeviceCRUDPages/update';
import ShareDevice from './pages/DeviceCRUDPages/sharedevice';
import TransferDevice from './pages/DeviceCRUDPages/transferdevice';

import CreateUnassociatedDevice from './pages/UnassociatedDeviceCRUDPages/create';
import ReadUnassociatedDevice from './pages/UnassociatedDeviceCRUDPages/read';
import UpdateUnassociatedDevice from './pages/UnassociatedDeviceCRUDPages/update';

import CreateSharedDevice from './pages/SharedDeviceCRUDPages/create';
import ReadSharedDevice from './pages/SharedDeviceCRUDPages/read';
import UpdateSharedDevice from './pages/SharedDeviceCRUDPages/update';

import CreateBuilding from './pages/BuildingCRUDPages/create';
import ReadBuilding from './pages/BuildingCRUDPages/read';
import UpdateBuilding from './pages/BuildingCRUDPages/update';

import CreateMembership from './pages/MembershipCRUDPages/create';
import ReadMembership from './pages/MembershipCRUDPages/read';
import UpdateMembership from './pages/MembershipCRUDPages/update';

import Login from './components/Login';
import Profile from "./components/Profile";
import Register from "./components/Register";

import HunterReport from "./components/HunterReport";
import DogsReport from "./components/DogsReport";
import AwardsReport from "./components/AwardsReport";

import HuntersReportAll from "./components/HuntersReportAll";
import DogsReportAll from "./components/DogsReportAll";
import RiflesReportAll from "./components/RiflesReportAll";
import AwardsReportAll from "./components/AwardsReportAll";
import PunishmentsReportAll from "./components/PunishmentsReportAll";
import BuildingsReportAll from "./components/BuildingsReportAll";
import ActionsReportAll from "./components/ActionsReportAll";
import MeetingsReportAll from "./components/MeetingsReportAll";
import LicencesReportAll from "./components/LicencesReportAll";
import TrofejsReportAll from "./components/TrofejsReportAll";
import SharedDevices from "./components/SharedDevices";
import UnassociatedDevices from "./components/UnassociatedDevices";
import OnlineDevices from "./components/OnlineDevices";

import HistoryHuntersDevicesAll from "./components/HistoryHuntersDevicesAll";

import HistoryActiveDates from "./components/HistoryActiveDates";

import UnpaidDevices from "./components/UnpaidDevices";

import Mapa from "./components/Mapa";
import MapaLive from "./components/MapaLive";
import MapaLiveMultiple from "./components/MapaLiveMultiple";
import MapaLiveMultipleAnalyse from "./components/MapaLiveMultipleAnalyse";
import HistoryMapa from "./components/HistoryMapa";

import Bills from "./components/Bills";

// ----------------------------------------------------------------------

export default function Router() {
	const routes = useRoutes([
		{ path: '/login', element: <Login /> },
		{ path: '/profile', element: <Profile /> },
		{ path: '/register', element: <Register /> },

		{ path: '/HunterReport', element: <HunterReport /> },
		{ path: '/DogsReport', element: <DogsReport /> },
		{ path: '/AwardsReport', element: <AwardsReport /> },


		{ path: '/HuntersReportAll', element: <HuntersReportAll /> },
		{ path: '/DogsReportAll', element: <DogsReportAll /> },
		{ path: '/RiflesReportAll', element: <RiflesReportAll /> },
		{ path: '/AwardsReportAll', element: <AwardsReportAll /> },
		{ path: '/BuildingsReportAll', element: <BuildingsReportAll /> },
		{ path: '/ActionsReportAll', element: <ActionsReportAll /> },
		{ path: '/MeetingsReportAll', element: <MeetingsReportAll /> },


		{ path: '/SLOBiHClanovi', element: <SLOBiHClanovi /> },

		{ path: '/SLOBiHClanovi/create', element: <CreateHunter /> },
		{ path: '/SLOBiHClanovi/read', element: <ReadHunter /> },
		{ path: '/SLOBiHClanovi/update', element: <UpdateHunter /> },

		{ path: '/SLOBiHRifles/create', element: <CreateRifle /> },
		{ path: '/SLOBiHRifles/read', element: <ReadRifle /> },
		{ path: '/SLOBiHRifles/update', element: <UpdateRifle /> },

		{ path: '/SLOBiHAwards/create', element: <CreateAward /> },
		{ path: '/SLOBiHAwards/read', element: <ReadAward /> },
		{ path: '/SLOBiHAwards/update', element: <UpdateAward /> },

		{ path: '/SLOBiHPunishments/create', element: <CreatePunishment /> },
		{ path: '/SLOBiHPunishments/read', element: <ReadPunishment /> },
		{ path: '/SLOBiHPunishments/update', element: <UpdatePunishment /> },

		{ path: '/SLOBiHDogs/create', element: <CreateDog /> },
		{ path: '/SLOBiHDogs/read', element: <ReadDog /> },
		{ path: '/SLOBiHDogs/update', element: <UpdateDevice /> },
		{ path: '/SLOBiHDogs/sharedevice', element: <ShareDevice /> },
		{ path: '/SLOBiHDogs/transferdevice', element: <TransferDevice /> },

		{ path: '/SharedDevices/create', element: <CreateSharedDevice /> },
		{ path: '/SharedDevices/read', element: <ReadSharedDevice /> },
		{ path: '/SharedDevices/update', element: <UpdateSharedDevice /> },

		{ path: '/UnassociatedDevices/create', element: <CreateUnassociatedDevice /> },
		{ path: '/UnassociatedDevices/read', element: <ReadUnassociatedDevice /> },
		{ path: '/UnassociatedDevices/update', element: <UpdateUnassociatedDevice /> },

		{ path: '/SLOBiHMemberships/create', element: <CreateMembership /> },
		{ path: '/SLOBiHMemberships/read', element: <ReadMembership /> },
		{ path: '/SLOBiHMemberships/update', element: <UpdateMembership /> },

		{ path: '/SLOBiHBuildings/create', element: <CreateBuilding /> },
		{ path: '/SLOBiHBuildings/read', element: <ReadBuilding /> },
		{ path: '/SLOBiHBuildings/update', element: <UpdateBuilding /> },

		{
			path: '/dashboard', element: <DashboardLayout />,
			children: [
				{ element: <Navigate to="/dashboard/app" />, index: true },
				{ path: 'app', element: <DashboardAppPage /> },
				{ path: 'users', element: <UsersPage /> },
				{ path: 'SLOBiHClanovi', element: <SLOBiHClanovi /> },
				{ path: 'HuntersReportAll', element: <HuntersReportAll /> },
				{ path: 'DogsReportAll', element: <DogsReportAll /> },
				{ path: 'SharedDevices', element: <SharedDevices /> },
				{ path: 'UnassociatedDevices', element: <UnassociatedDevices /> },
				{ path: 'OnlineDevices', element: <OnlineDevices /> },
				{ path: 'HistoryHuntersDevicesAll', element: <HistoryHuntersDevicesAll /> },
				{ path: 'HistoryActiveDates', element: <HistoryActiveDates /> },
				{ path: 'UnpaidDevices', element: <UnpaidDevices /> },
				{ path: 'Mapa', element: <Mapa /> },
				{ path: 'MapaLive', element: <MapaLive /> },
				{ path: 'MapaLiveMultiple', element: <MapaLiveMultiple /> },
				{ path: 'MapaLiveMultipleAnalyse', element: <MapaLiveMultipleAnalyse /> },
				{ path: 'HistoryMapa', element: <HistoryMapa /> },
				{ path: 'Bills', element: <Bills /> },
				{ path: 'RiflesReportAll', element: <RiflesReportAll /> },
				{ path: 'AwardsReportAll', element: <AwardsReportAll /> },
				{ path: 'PunishmentsReportAll', element: <PunishmentsReportAll /> },
				{ path: 'BuildingsReportAll', element: <BuildingsReportAll /> },
				{ path: 'ActionsReportAll', element: <ActionsReportAll /> },
				{ path: 'MeetingsReportAll', element: <MeetingsReportAll /> },
				{ path: 'LicencesReportAll', element: <LicencesReportAll /> },
				{ path: 'TrofejsReportAll', element: <TrofejsReportAll /> },
				{ path: 'devices', element: <DevicesPage /> },
				{ path: 'userdevices', element: <UserDevicesPage vlasnik="212" /> },
				{ path: 'clanoruzje', element: <ClanOruzje vlasnik="5" /> },
				{ path: 'clankerovi', element: <ClanKerovi vlasnik="5" /> },
				{ path: 'clanodlikovanja', element: <ClanOdlikovanja vlasnik="5" /> },
				{ path: 'clanprofil', element: <ClanProfil vlasnik="2" /> },
				{ path: 'online_devices', element: <OnlineDevicesPage /> },
				{ path: 'test', element: <TestPage /> },
				{ path: 'products', element: <ProductsPage /> },
				{ path: 'blog', element: <BlogPage /> },
			],
		},
		{
			element: <SimpleLayout />,
			children: [
				{ element: <Navigate to="/dashboard/app" />, index: true },
				{ path: '404', element: <Page404 /> },
				{ path: '*', element: <Navigate to="/404" /> },
			],
		},
		{
			path: '*',
			element: <Navigate to="/404" replace />,
		},
	]);

	return routes;
}
